<template>
  <div class="c-subject">
    <div>
    <span class="c-subject__header">学科分布</span>
    <div class="distribute">
      <div class="accurate-distribute">
      </div>
      <div class="subject-num">
      <div class="subject-bg">
        <img src="../../images/radius-bg.png" alt="">
      </div>
      <div class="subject-circle"></div>
      <p class="test-num">测评数量</p>
      <p class="test-total">{{data.evaluation_num}}</p>
      </div>
    </div>
    </div>

    <AccurateGrade
    :graspList="data.student_distribution"/>
  </div>
</template>

<script>
import AccurateGrade from './accurate-grade.vue';

export default {
  name: 'SubjectDistribute',
  components: {
    AccurateGrade,
  },
  props: {
    data: {
      require: true,
      default: () => [],
    },
  },
  data() {
    return {
      total: 234,
    };
  },
  watch: {
    data() {
      this.initCharts();
    },
  },
  mounted() {

  },
  methods: {
    initCharts() {
      const that = this;
      // 基于准备好的dom，初始化echarts实例
      const myChart = this.$echarts.init(document.querySelector('.accurate-distribute'));
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'item',
        },
        series: [
          {
            type: 'pie',
            radius: ['39%', '49%'],
            center: ['49%', '43%'],
            avoidLabelOverlap: false,
            labelLine: {
              length: 32,
              length2: 60,
            },
            label: {
              normal: {
                show: true,
                formatter(params) {
                  // 自定义颜色
                  const res = `{name|${params.data.name}}`
                  + '\n\r'
                  + `{value|${`${params.data.value}个`}}`;
                  return res;
                },
                rich: {
                  name: {
                    fontSize: 20,
                    fontFamily: 'PingFangSC-Regular, PingFang SC',
                    fontWeight: 500,
                    color: '#fff',
                    lineHeight: 30,
                  },
                  value: {
                    fontFamily: 'PingFangSC-Semibold, PingFang SC',
                    fontSize: 18,
                    color: '#00DEFF',
                  },
                },
              },
            },
            // itemStyle: {
            //   borderColor: '#263180',
            // borderWidth: 10,
            // },

            data: [{
              value: that.data.evaluation_num,
              name: '数学 100%',
              itemStyle: {
                normal: {
                  color: this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                    offset: 0,
                    color: '#ECFF48',
                  }, {
                    offset: 1,
                    color: '#FFE500',
                  }]),
                },
              },
            },
            ],
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.c-subject{
  box-sizing: border-box;
  width: 1283px;
  height: 404px;
  padding: 26px 40px 0 0;
  margin-left:40px ;
  background: url('../../images/grade_distribution.png') no-repeat ;
  background-size:100% 100%;
  display: flex;
   &__header {
     display: block;
        position: relative;
        font-size: 28px;
        font-weight: 500;
        text-indent: 1em;
        margin-left:46px ;
        color: #E3E2FF;
        &::before {
          content: '';
          position: absolute;
          width: 27px;
          height: 27px;
          top: 9px;
          left: -8px;
          background: url('../../images/cockpit-icon.png') no-repeat center / contain;
        }
      }
  .distribute{
  position: relative;
  display: inline-block;
  .accurate-distribute{
    width: 600px;
    height: 359px;
  }
   .subject-num{
      .subject-bg{
        width: 242px;
        height: 242px;
        position: absolute;
        top: 43%;
        left: 49%;
        transform: translate(-50%,-50%);
      }
       .subject-circle{
        width: 140px;
        height: 140px;
        position: absolute;
        top: 43%;
        left: 49%;
        transform: translate(-50%,-50%);
        background: #7DDCFF;
        opacity: 0.16;
        border-radius: 50%;
      }
      .test-num{
        position: absolute;
        top: 40%;
        left: 49%;
        transform: translate(-50%,-50%);
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #fff;
      }
      .test-total{
        position: absolute;
        top: 49%;
        left: 49%;
        transform: translate(-50%,-50%);
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #fff;
      }
    }
}
}
</style>
